<template>
    <fade-up-animation :element="() => $refs.section">
        <section
            class="three-column-grid-section"
            :class="[
                `background-${ backgroundVariant }`,
            ]"
            ref="section"
        >
            <b-container>
                <h2 v-test:title>{{ title }}</h2>

                <component
                    :is="gridType === 'carousel' ? 'base-carousel' : 'b-row'"
                    :breakpoints="gridType === 'carousel' ? carouselBreakpoints : undefined"
                >
                    <component
                        v-for="(column, i) in columns"
                        :is="gridType === 'carousel' ? 'div' : 'b-col'"
                        :slot="gridType === 'carousel' ? `slot_${ i }` : undefined"
                        :md="gridType === 'grid' ? '4' : undefined"
                        :key="`slot_${ i }`"
                    >
                        <lazy-image
                            v-if="column.image.src"
                            :src="column.image.src"
                            :alt="column.image.alt"
                            :width="column.image.width"
                            :height="column.image.height"
                            v-test:image
                        />

                        <markdown-content
                            class="text"
                            :content="column.text"
                        />
                    </component>

                    <template
                        v-if="gridType === 'carousel'"
                        #pagination="{ active, total }"
                    >
                        <div
                            class="pagination"
                            v-test:pagination
                        >
                            {{ active + 1 }} {{ $snippet('pagination_of', 'of') }} {{ total }}
                        </div>
                    </template>
                </component>
            </b-container>
        </section>
    </fade-up-animation>
</template>

<script>
    import MarkdownContent from '../../utils/MarkdownContent/MarkdownContent';
    import BaseCarousel from '../../molecules/BaseCarousel/BaseCarousel';
    import { ITSU_VARIANT_DEFAULT, ITSU_VARIANTS } from '../../../plugins/constants';

    export default {
        name: 'three-column-grid-section',

        components: { BaseCarousel, MarkdownContent },

        props: {
            title: {
                type: String,
                required: true,
            },

            columns: {
                type: Array,
                default: () => ([]),
            },

            backgroundVariant: {
                type: String,
                default: ITSU_VARIANT_DEFAULT,
                validator: (val) => ITSU_VARIANTS.includes(val),
            },

            gridType: {
                type: String,
                default: 'carousel',
            },
        },

        computed: {
            /**
             * Return the carousel breakpoints.
             *
             * @returns {{'0': {slidesPerView: number}, '992': {slidesPerView: number}}}
             */
            carouselBreakpoints() {
                return {
                    0: {
                        slidesPerView: 1,
                    },
                    992: {
                        slidesPerView: 3,
                    },
                };
            },
        },
    };
</script>

<style lang="scss" scoped>
    .three-column-grid-section {
        padding: 65px 0;
        text-align: center;
    }

    @each $variant, $colour in $itsu-variants {
        .background-#{ $variant } {
            background-color: $colour;
        }
    }

    .background-blue,
    .background-pink {
        color: #ffffff;

        .pagination {
            color: inherit;
        }
    }

    .background-blue,
    .background-yellow,
    .background-pink {
        h2 {
            color: inherit;
        }
    }

    h2 {
        color: $primary;
        margin-bottom: rem(50px);
        font-weight: bold;
    }

    img {
        margin-bottom: 30px;
        max-width: 100%;
        height: auto;
    }

    .text {
        max-width: 300px;
        margin: 0 auto;

        ::v-deep p:last-child {
            margin-bottom: 0;
        }
    }

    .pagination {
        color: secondary-palette(5);
        text-align: center;
        margin-top: 30px;
        font-weight: 300;

        @include media-breakpoint-up(lg) {
            display: none;
        }
    }

    .row {
        row-gap: $grid-gutter-width;
    }
</style>
